<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Contract Goals" class="px-4 pr-5 mb-5">
      </SimplePageHeader>
      <v-row
        align="center"
        justify="start"
        class="px-5 mb-sm-5"
      >
        <v-col cols="6" sm="3" md="2">
          <v-text-field
            label="Year"
            v-model="selectedYear"
            validate-on-blur
            outlined
            :maxlength="4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="12" sm="6">
          <FilterButtons
            @search="handleSearchClick"
            @clear="handleClearClick"
          ></FilterButtons>
        </v-col>
      </v-row>
      <FilterButtonsSmall
        @search="handleSearchClick"
        @clear="handleClearClick"
      ></FilterButtonsSmall>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-card class="pt-3">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <PlacementGoalsInput
                :placementGoals="placementGoals"
                :placementNetGoals="placementNetGoals"
                @placementGoalChange="(newValue) => { this.placementGoals = newValue }"
              ></PlacementGoalsInput>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <ButtonsSubmitForm
      :is-form-valid="true"
      @save="handleSavePlacementGoals"
      @cancel="cancel"
    >
    </ButtonsSubmitForm>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { FilterButtons, FilterButtonsSmall, BottomSpacer, ButtonsSubmitForm } from '@/components/buttons'
import PlacementGoalsInput from '@/components/assignments/PlacementGoalsInput'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { dashboardRoute } from '@/lib/constants/routes'

export default {
  components: {
    SimplePageHeader,
    FilterButtons,
    FilterButtonsSmall,
    BottomSpacer,
    PlacementGoalsInput,
    ButtonsSubmitForm
  },
  data () {
    return {
      selectedYear: new Date().getFullYear()
    }
  },
  methods: {
    ...mapActions('placementGoals', ['getPlacementGoals', 'savePlacementGoals']),
    handleSearchClick () {
      this.getPlacementGoals(this.selectedYear)
    },
    handleClearClick () {
      this.selectedYear = new Date().getFullYear()
      this.getPlacementGoals()
    },
    handleSavePlacementGoals () {
      this.savePlacementGoals(this.placementGoals)
    },
    cancel () {
      this.$router.push(dashboardRoute)
    }
  },
  computed: {
    ...mapFields('placementGoals', [
      'placementGoals',
      'placementNetGoals'
    ])
  },
  mounted () {
    this.getPlacementGoals()
  }
}
</script>
